import { Link } from "react-router-dom";
import { NEWS_CATEGORIES } from "@/mocks/types";

export default function NewsQuickLinks() {
  const categories = NEWS_CATEGORIES.filter((c) => c.key !== "all");

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
      {categories.map((cat, idx) => (
        <Link
          key={cat.key}
          to={`/news?category=${encodeURIComponent(cat.key)}`}
          className="group relative p-4 md:p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors duration-300 cursor-pointer animate-fade-up"
          style={{ animationDelay: `${idx * 60}ms` }}
        >
          <div className="w-10 h-10 rounded-md bg-primary-100 text-primary-600 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
            <i className={`${cat.icon} text-lg`} />
          </div>
          <h3 className="mt-3 font-heading font-semibold text-foreground-950 text-sm md:text-base">{cat.label}</h3>
          <p className="mt-1 text-[11px] md:text-xs text-foreground-500 leading-relaxed">{cat.desc}</p>
          <span className="mt-3 inline-flex items-center gap-1 text-[11px] text-primary-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            进入分类
            <i className="ri-arrow-right-line" />
          </span>
        </Link>
      ))}
    </div>
  );
}